import { useContext, useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { translate } from "../utils/Common";
import AuthContext from "../contexts/auth";
import ThemeContext from "../contexts/theme";
import { usePlatforms } from "../hooks/usePlatforms";
import { getReactSelectStyles } from "../utils/reactSelectThemeStyles";
import { PiLockersFill } from "react-icons/pi";
import { SelectShell } from "@/components/ui/select-shell";
import ignoreAbort from '../utils/ignoreAbort';

const LockersSearchList = (props) => {
  const userContext = useContext(AuthContext);
  const themeContext = useContext(ThemeContext);
  const theme = themeContext?.theme || "light";
  const selectStyles = useMemo(() => getReactSelectStyles(theme, { hasIcon: true }), [theme]);
  const { platforms, getPlatforms } = usePlatforms();
  const [lockersList, setLockersList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();

    const loadLockers = async () => {
      setLoading(true);
      const list = await getPlatforms(userContext.user?.IdCliente, abortController.signal);
      if (list && Array.isArray(list)) {
        const options = list.map((item) => ({
          value: item.boxitLocationId,
          label: item.locationName || String(item.boxitLocationId),
          ...item,
        }));
        setLockersList(options);
      } else {
        setLockersList([]);
      }
      setLoading(false);
    };

    if (!platforms) {
      loadLockers().catch(ignoreAbort);
    } else {
      const options = platforms.map((item) => ({
        value: item.boxitLocationId,
        label: item.locationName || String(item.boxitLocationId),
        ...item,
      }));
      setLockersList(options);
      setLoading(false);
    }

    return () => abortController.abort();
  }, [platforms, getPlatforms, userContext.user?.IdCliente]);

  const selectOptions = useMemo(() => lockersList, [lockersList]);

  useEffect(() => {
    if (props.value == null || props.value === "") {
      setSelectedOption(null);
    }
  }, [props.value]);

  const controlledValue = props.value != null && props.value !== ""
    ? selectOptions.find((opt) => opt.value === Number(props.value) || opt.value === props.value) ?? selectedOption
    : selectedOption;

  return (
    <SelectShell
      icon={<PiLockersFill size={16} />}
      error={props?.errors?.[props.fieldName || "platformId"]}
    >
        <Select
          value={controlledValue}
          onInputChange={() => {}}
          options={selectOptions}
          isLoading={loading}
          placeholder={props.placeholder || translate("global.selectLocker")}
          name={props.name || "platformId"}
          onChange={(e) => {
            setSelectedOption(e);
            const value = e ? e.value : null;
            props.setSelectOption(value);
          }}
          required={props.isRequired}
          isClearable
          isSearchable
          filterOption={(option, search) =>
            option.label.toLowerCase().includes((search || "").toLowerCase())
          }
          noOptionsMessage={() => translate("global.noPlatforms")}
          styles={selectStyles}
        />
    </SelectShell>
  );
};

export default LockersSearchList;
